export default "__VITE_ASSET__d787082d__"